import { render } from "./RatingPage.vue?vue&type=template&id=696a7973&scoped=true"
import script from "./RatingPage.vue?vue&type=script&lang=js"
export * from "./RatingPage.vue?vue&type=script&lang=js"

import "./RatingPage.vue?vue&type=style&index=0&id=696a7973&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696a7973"]])

export default __exports__